module.exports = __webpack_public_path__ + "img/17_32.11d8cf99.png";